module.exports = __webpack_public_path__ + "static/Primary-Composite-4@2x-ca6193e8d672f65cf0b9944a07d1bf8f.png";